import axios from "axios";
import { del, get, post, patch,  put } from "./evaluations_api_helper";
import * as url from "./evaluations_url_helper";





// Get features
export const getEvaluations = (params) => get(url.GET_EVALUATIONS,  { params });

// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewEvaluation = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewEvaluation = evaluation => post(url.ADD_NEW_EVALUATION, evaluation);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateEvaluation = evaluation => patch(`${url.UPDATE_EVALUATION}/${evaluation.id}`,  evaluation);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteEvaluation = evaluation => del(`${url.DELETE_EVALUATION}/${evaluation.id}`);


// Récupérer les moyennes d'une évaluation
export const getAverageByEvaluation = (evaluationUuid) => get(`${url.DELETE_EVALUATION}/${evaluationUuid}/average`);





export {
  //getLoggedInUser,
  
  
};
